import { render, staticRenderFns } from "./subdepartment.vue?vue&type=template&id=707d4c4a&scoped=true&"
import script from "./subdepartment.vue?vue&type=script&lang=js&"
export * from "./subdepartment.vue?vue&type=script&lang=js&"
import style0 from "./subdepartment.vue?vue&type=style&index=0&id=707d4c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d4c4a",
  null
  
)

export default component.exports